if (!customElements.get('shop-categories-slider')) {
  class ShopCategoriesSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;

      this.cards = Array.from(this.track.children);
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      this.currentEl = this.querySelector('[data-current]');
      this.totalEl = this.querySelector('[data-total]');
      this.index = 0;

      if (this.cards.length === 0) return;

      if (this.totalEl) this.totalEl.textContent = this.cards.length;
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(this.index - 1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(this.index + 1));

      this.setupObserver();
      this.updateCounter();
    }

    setupObserver() {
      if (!('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(
        (entries) => {
          let best = null;
          entries.forEach((entry) => {
            if (entry.isIntersecting && (!best || entry.intersectionRatio > best.intersectionRatio)) {
              best = entry;
            }
          });
          if (best) {
            const idx = this.cards.indexOf(best.target);
            if (idx > -1 && idx !== this.index) {
              this.index = idx;
              this.updateCounter();
            }
          }
        },
        { root: this.track, threshold: [0.6] }
      );
      this.cards.forEach((card) => this.observer.observe(card));
    }

    go(next) {
      const total = this.cards.length;
      const clamped = Math.max(0, Math.min(total - 1, next));
      const card = this.cards[clamped];
      if (!card) return;

      const trackRect = this.track.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();
      const targetScrollLeft = this.track.scrollLeft + (cardRect.left - trackRect.left);

      this.track.scrollTo({ left: targetScrollLeft, behavior: 'smooth' });
      this.index = clamped;
      this.updateCounter();
    }

    updateCounter() {
      if (this.currentEl) this.currentEl.textContent = this.index + 1;
      if (this.prevBtn) this.prevBtn.disabled = this.index === 0;
      if (this.nextBtn) this.nextBtn.disabled = this.index === this.cards.length - 1;
    }
  }

  customElements.define('shop-categories-slider', ShopCategoriesSlider);
}
